import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'

export const useCancelToken = (message = '') => {
  const dispatch = useDispatch()
  const { CancelToken: cancelToken } = axios
  const sourceRef = useRef(null)

  const newCancelToken = () => {
    sourceRef.current = cancelToken.source()
    return sourceRef.current.token
  }

  const cancelPreviousRequest = () => {
    console.logXHR('cancelling previous request')
    if (sourceRef.current) {
      sourceRef.current.cancel(message)
    }
  }

  useEffect(() => {
    return () => {
      cancelPreviousRequest()
    }
  }, [])

  return {
    cancelableDispatch: (action) =>
      dispatch({
        ...action,
        cancelToken: newCancelToken(),
      }),
    cancelPreviousRequest,
  }
}
